import { render, staticRenderFns } from "./CommonAttachmentModalTree.vue?vue&type=template&id=a60864ea&"
import script from "./CommonAttachmentModalTree.vue?vue&type=script&lang=js&"
export * from "./CommonAttachmentModalTree.vue?vue&type=script&lang=js&"
import style0 from "./CommonAttachmentModalTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports